// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"b43c9271","945":"0b4df7b0"}[chunkId] + ".chunk.css";
};